<template>

    <div class="ac" :class="{'ac__fixed': isList}">

        <div class="ac__help-ghost"></div>

        <div class="ac__blur" :class="{'ac__blur__bankai': isCardsDesktop}">
            <button class="ac__btn ac__btn__red" @click="action(ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES)">
                <img :src="computedImgUnsubscribes" class="img__28">
            </button>
            <img src="/img/newsletters-v2/delete-red-auto.svg" class="img__28 mt__16" v-show="isCardsDesktop">
        </div>
        <div class="ac__blur" :class="{'ac__blur__bankai': isCardsDesktop}">
            <button class="ac__btn ac__btn__orange" @click="action(ENUM.NEWSLETTERS.ACTIONS.DELETE)">
                <img :src="computedImgDelete" class="img__28">
            </button>
            <img src="/img/newsletters-v2/delete-orange-simple.svg" class="img__28 mt__16" v-show="isCardsDesktop">
        </div>
        <div class="ac__blur" :class="{'ac__blur__bankai': isCardsDesktop}">
            <button class="ac__btn ac__btn__green" @click="action(ENUM.NEWSLETTERS.ACTIONS.KEEP)">
                <img :src="computedImgKeep" class="img__28">
            </button>
            <img src="/img/newsletters-v2/archive-i-os-green.svg" class="img__28 mt__16" v-show="isCardsDesktop">
        </div>

        <button class="ac__help" @click="openHelp">
            <img src="/img/newsletters-v2/question-mark-circle.svg" :class="$mq === 'lg' ? 'img__40' : 'img__24'">
        </button>

        <help ref="HELP"></help>

    </div>

</template>

<script>
import ENUM from '@/assets/ENUM'

import Help from '@/components/newsletters-v2/Help'

export default {

    name: 'action-bar',
    components: {Help},
    props: {
        isList: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        ENUM() {
            return ENUM
        },

        computedImgUnsubscribes() {
            return this.isCardsDesktop
                ? '/img/newsletters-v2/arrow-white-left.svg'
                : '/img/newsletters-v2/delete-white-auto.svg'
        },

        computedImgDelete() {
            return this.isCardsDesktop
                ? '/img/newsletters-v2/arrow-white-up.svg'
                : '/img/newsletters-v2/delete-white-simple.svg'
        },

        computedImgKeep() {
            return this.isCardsDesktop
                ? '/img/newsletters-v2/arrow-white-right.svg'
                : '/img/newsletters-v2/archive-i-os-white.svg'
        },

        isCardsDesktop() {
            return !this.isList && this.$mq === 'lg'
        }
    },

    methods: {

        action(enumAction) {
            this.$emit('action', enumAction)
        },

        openHelp() {
            this.$refs.HELP.open()
        }
    }
}
</script>

<style lang="scss" scoped>

.ac {

    &__fixed {
        position: fixed;
        bottom: 81px;
        padding: 0 16px;
        max-width: 100%;
        pointer-events: auto;
        @media screen and (min-width: $above-tablet-length) {
            bottom: 52px;
        }
    }

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;


    &__btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 56px;
        height: 56px;
        border-radius: 72px;

        @media screen and (min-width: $above-tablet-length) {
            width: 80px;
            height: 80px;
            border-radius: 8px;
        }

        &__red {
            background-color: $raspberry;
            border: solid 4px #fbc5d2;
        }

        &__orange {
            background-color: $sunset;
            border: solid 4px #f9d3b9;
        }

        &__green {
            background-color: $lime;
            border: solid 4px #aef1dc;
        }

    }

    &__help {
        min-width: 40px;
        height: 40px;
        border-radius: 72px;
        background-color: $white;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 0 8px 0 rgba(17, 17, 26, 0.1), 0 1px 0 0 rgba(17, 17, 26, 0.05);
        pointer-events: auto;


        @media screen and (min-width: $above-tablet-length) {
            position: fixed;
            right: 39px;
            bottom: 40px;
            width: 88px;
            height: 88px;
            box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.04), 0 4px 16px 0 rgba(0, 0, 0, 0.08);
            border: solid 2.5px #e7e7e8;
        }
    }

    &__help-ghost {
        min-width: 40px;

        @media screen and (min-width: $above-tablet-length) {
            width: 0;
        }
    }

    &__blur {
        width: 80px;
        height: 80px;
        border-radius: 80px;
        backdrop-filter: blur(3px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 16px;
        pointer-events: auto;

        @media screen and (min-width: $above-tablet-length) {
            width: 100px;
            height: 100px;
            margin: 0;
            border-radius: 2px
        }

        &__bankai {
            height: auto;
        }
    }
}

</style>
